import { createContext } from 'react';
import type { PluginErrorTranslationKey } from '../types';

export type RichTextEditorConfig = {
  onError: (message: string) => void;
  translations: {
    colors: Record<'black' | 'blue' | 'gray' | 'green' | 'orange' | 'red', string>;
    errors: Record<PluginErrorTranslationKey, string>;
    preview: string;
  };
};

export const RichTextEditorContext = createContext({
  onError: console.error,
  translations: {
    colors: {
      black: 'Black',
      blue: 'Blue',
      gray: 'Gray',
      green: 'Green',
      orange: 'Orange',
      red: 'Red',
    },
    errors: {
      fileAccessFailed: 'An error has occurred while accessing file.',
      fileUploadAborted: 'An error has occurred while uploading file.',
      fileUploadFailed: 'An error has occurred while uploading file.',
      sourceValidationFailed: 'An error has occurred while pasting file from clipboard.',
    },
    preview: 'Preview',
  },
});
